import { render } from "./RNavTop.vue?vue&type=template&id=45bf1a46"
import script from "./RNavTop.vue?vue&type=script&lang=js"
export * from "./RNavTop.vue?vue&type=script&lang=js"

import "./RNavTop.vue?vue&type=style&index=0&id=45bf1a46&lang=css"
script.render = render

export default script